"use client";

import { LCWork } from "@libry-content/integrations";
import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import { WorkView } from "../../../../../../../searchAndCollection/components/works/WorkView";
import { WorkViewContextProvider } from "../../../../../../../searchAndCollection/components/works/WorkViewContextProvider";
import { SanityPreviewLiveQuery } from "../../../../../../sanityFetcher/SanityPreviewLiveQuery";
import { WorkPageData } from "./page";

const WorkClientSide = ({ workParams, sanityData }: WorkPageData) => (
  <SanityPreviewLiveQuery sanityData={sanityData}>
    {(sanityData) => (
      <DefaultContainer withoutPaddingXBelow="lg">
        <WorkViewContextProvider
          work={new LCWork(workParams)}
          recommendation={sanityData.recommendation}
          libraries={sanityData.libraries}
          kulturFondVideo={sanityData.kulturfondVideo}
        >
          <WorkView />
        </WorkViewContextProvider>
      </DefaultContainer>
    )}
  </SanityPreviewLiveQuery>
);

export default WorkClientSide;
